import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from "@angular/common";
import { ToastService } from "../services/toast.service";

export interface WebShareApiDataInterface {
  title: string;
  text: string;
  url: string;
}

interface ExtendNavigator extends Navigator {
  share: (share: WebShareApiDataInterface) => Promise<void>;
}

interface ExtendWindow extends Window {
  navigator: ExtendNavigator;
}

declare var window: ExtendWindow;

@Component({
    selector: 'gea-shop-share-button',
    templateUrl: './share-button.component.html',
    styleUrl: './share-button.scss',
    standalone: false
})
export class ShareButtonComponent {
  @Input() shareData?: WebShareApiDataInterface

  constructor(
    @Inject(PLATFORM_ID) protected platformId: Object,
    @Inject(ToastService) protected toastService: ToastService
  ) {}

  onShare() {
    if (isPlatformServer(this.platformId)) return
    if (! this.shareData) return
    const shareData = this.shareData

    try {
      const result = window.navigator.share(shareData)
      if (result && typeof result.then === 'function') {
        result.catch((err: unknown) => {
          return
        })
      }
    } catch (err) {
      try {
        navigator.clipboard.writeText(shareData.url).then(() => {
          this.toastService.showSuccess('Der Link zur aktuellen Seite wurde in die Zwischenablage kopiert!')
        })
      } catch (err) {
        this.toastService.showError('Dein Browser unterstützt weder das Teilen mit Freunden und es ist auch nicht erlaubt, den Link in die Zwischenablage zu kopieren.')
      }
    }
  }
}
